<div class="login-container">
    <div class="login-card">
        <img src="assets/logos/forticloud-fortinet.svg" alt="FortiCloud Logo" class="logo" />
        <br />
        <button class="login-button" (click)="redirectToLogin()">Log In</button>
    </div>
</div>
